import BaseConfigApi from "../BaseConfigApi";

export default abstract class BaseQuestionApi extends BaseConfigApi {
	protected override getBaseUrl(params: Record<string, string>) {
		return `${super.getBaseUrl(params)}/questions`;
	}
}
